import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Arrow = ({ onClick, label, testId, children }) => (
  <button type="button" onClick={onClick} aria-label={label} data-testid={testId}
    className="grid h-9 w-9 place-items-center rounded-full border border-white/25 text-white transition-colors hover:bg-white hover:text-ink">
    {children}
  </button>
);

/** Auto-advancing fact cards (pauses on hover); arrows and dots let people click through at their own pace. */
export const FactDeck = ({ facts, interval = 7000, testId = "fact-deck" }) => {
  const [i, setI] = useState(0);
  const [hold, setHold] = useState(false);
  const n = facts.length;
  useEffect(() => {
    if (hold) return undefined;
    const t = setTimeout(() => setI((x) => (x + 1) % n), interval);
    return () => clearTimeout(t);
  }, [i, hold, interval, n]);
  const f = facts[i];

  return (
    <div onMouseEnter={() => setHold(true)} onMouseLeave={() => setHold(false)} data-testid={testId}>
      <div className="flex items-center justify-between">
        <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-white/70" data-testid={`${testId}-counter`}>Fact {i + 1} / {n}</p>
        <div className="flex gap-2">
          <Arrow onClick={() => setI((x) => (x - 1 + n) % n)} label="Previous fact" testId={`${testId}-prev`}><ChevronLeft className="h-4 w-4" /></Arrow>
          <Arrow onClick={() => setI((x) => (x + 1) % n)} label="Next fact" testId={`${testId}-next`}><ChevronRight className="h-4 w-4" /></Arrow>
        </div>
      </div>
      <div key={i} className="mt-5 min-h-[190px] animate-rise-in" data-testid={`${testId}-card`}>
        <p className="font-display text-4xl text-brass sm:text-5xl">{f.big}</p>
        <p className="mt-2 text-lg font-medium text-white">{f.title}</p>
        <p className="mt-2 text-[15px] leading-relaxed text-white/80">{f.body}</p>
      </div>
      <div className="mt-4 flex gap-1.5">
        {facts.map((x, j) => (
          <button key={x.title} type="button" onClick={() => setI(j)} aria-label={`Fact ${j + 1}`} data-testid={`${testId}-dot-${j}`}
            className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${j === i ? "w-8 bg-brass" : "w-3 bg-white/30 hover:bg-white/60"}`} />
        ))}
      </div>
    </div>
  );
};
